import React, {Fragment, useCallback, useEffect, useRef, useState} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import DataGrid from "../../form/SelectorGrid/DataGrid";
import {AddressFormatter, DateTimeFormatter} from "../../../utils/formatters";
import {postData, UrlGenerator} from "../../../utils/request";
import Confirm, {smallDeleteProps} from "../../form/Confirm";
import CodeScanner from "../../form/CodeScanner";
import UIfx from "uifx";
import beepErrorMp3 from "../../../sounds/beep-error.mp3";
import beepSuccessMp3 from "../../../sounds/beep-success.mp3";
import classNames from "classnames";
import ContentLoader from "../../layout/ContentLoader";
import Modal from "../../layout/Modal";
import Pagination from "../../form/SelectorGrid/DataGrids/Table/Pagination";
import Portal from "../../layout/Portal";
import {list} from "../../../utils/array";
import CheckBox from "../../form/CheckBox";
import {Tooltip} from "react-tippy";
import SignaturePad from "../../form/SignaturePad";
import debounce from "../../../utils/debounce";
import Button from "../../form/Button";
import {loadComponent} from "../../../utils/components";
import {refs} from "../../../utils/refs";

function removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

const beepError = new UIfx(beepErrorMp3, {});
const beepSuccess = new UIfx(beepSuccessMp3, {});

const sortable = true;
const filterable = true;

const PossibleOrders = (props) => {
    const {possibleOrdersOpened, setPossibleOrdersOpened} = props;
    return <Fragment>
        <a className="list-group-item" href="" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setPossibleOrdersOpened(props.groupage.destination + "-" + props.groupage.partner.partner_id);
        }}>Lehetséges csomagok</a>
        <Portal>
            <Modal
                state={props.groupage.destination + "-" + props.groupage.partner.partner_id === possibleOrdersOpened}
                size="large"
                header="Lehetséges csomagok"
                buttons={[
                    {
                        text: "Bezárás",
                        className: "pull-left",
                        props: {
                            color: "default",
                            disabled: props.disabled || props.isLoading
                        },
                        onClose: true,
                        onClick: () => {
                            setPossibleOrdersOpened(!possibleOrdersOpened);
                        }
                    }
                ]}
            >
                <DataGrid
                    component="shippingorder"
                    type={ShippingOrderTable}
                    view={["shippingorder_id"]}
                    filter={[
                        {field: "groupage", operator: "isnull"},
                        {field: "serviceprovider_type", value: "booklog_shipping"},
                        {field: "partner", value: props.groupage.partner.partner_id},
                        {field: "origin", value: props.groupage.origin},
                        {field: "destination", value: props.groupage.destination},
                        {field: "state", value: 0},
                    ]}
                    fields={{
                        "tracking_id": {
                            props: {
                                header: 'Követési kód',
                                width: 1,
                                sortable,
                                filterable
                            }
                        },
                        "pid": {
                            props: {
                                header: 'Azonosító',
                                width: 1,
                                sortable,
                                filterable
                            }
                        },
                        "partner.name": {
                            props: {
                                header: 'Megrendelő',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin_address": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "destination": {
                            props: {
                                header: 'Címzett',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "destination_address": {
                            props: {
                                header: 'Hová',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "order_date": {
                            props: {
                                header: 'Rendelés időpontja',
                                order: "DESC",
                                width: 2,
                                sortable,
                                filterable,
                                formatter: ({value}) => DateTimeFormatter(value)
                            }
                        },
                        "state": {
                            props: {
                                header: 'Státusz',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                    }}
                />
            </Modal>
        </Portal>
    </Fragment>
}

const ShippingOrderTable = (props) => {
    const [possibleOrdersOpened, setPossibleOrdersOpened] = useState(false);
    return <div className="p-datagrid p-datacards">
        <div className="row">
            {props.data.items.map((item, rowIdx) => {

                let selectedIdx = props.selectorFunction({
                    item,
                    items: props.data.items,
                    selection: props.selection,
                    props: props
                });

                return <div key={rowIdx} className="col-md-4 my-1">
                    <div
                        className={classNames("card", {"card-primary": selectedIdx !== -1})}
                        onClick={() => {
                            if (possibleOrdersOpened) return;
                            props.onSelectionChange && props.onSelectionChange({item, selectedIdx, rowIdx});
                        }}
                    >
                        <div className="card-body">
                            <div className="card-title"><b>{item.pid}</b></div>
                            <div className="card-title"><b>{item.tracking_id}</b></div>
                            <div className="card-text">{item.destination}</div>
                            <div className="card-text"><i>{AddressFormatter(item.destination_address)}</i></div>
                            <div className="card-subtitle mb-2 text-muted">{item.partner.name}</div>
                            <div className="card-text">{item.order_date}</div>
                        </div>
                        <ul className="list-group list-group-flush">
                            {AddressFormatter(item.destination_address) ?
                                <a className="list-group-item" onClick={(e) => {
                                    e.preventDefault(); e.stopPropagation();
                                    window.open("https://maps.google.com/?q=" + encodeURIComponent(AddressFormatter(item.destination_address).split(';').shift()), "_blank");
                                }} href={"https://maps.google.com/?q=" + encodeURIComponent(AddressFormatter(item.destination_address).split(';').shift())} target="_blank">Térkép</a>
                            : null}
                            {props.possibleOrders ?
                                <PossibleOrders {...props} selection={undefined} groupage={item} possibleOrdersOpened={possibleOrdersOpened} setPossibleOrdersOpened={setPossibleOrdersOpened} />
                             : null}
                            {
                                props.name &&
                                    parseInt(props.parent.state || "0") === 0 ? <Confirm
                                        {...smallDeleteProps}
                                        onAccept={() => props.removeItems([item])}
                                    >
                                        <li className="list-group-item list-group-item-danger">Törlés</li>
                                    </Confirm> : null
                            }
                        </ul>
                    </div>
                </div>
            })}
        </div>
        <Pagination {...props} />
        {props.isLoading ? <div className="loader"><ContentLoader /></div> : null}
    </div>
}

const CountGroupageShippingOrder = (props) => {
    const [fullCount, setFullCount] = useState(null);
    const [inGroupageCount, setInGroupageCount] = useState(null);
    const loadList = (groupage_id, type) => {
        let loadList;
        let timeout = setTimeout(() => {
            loadList = loadComponent("componentlist", {
                component: "shippingorder",
                filter: type === "part" ? [
                    {field: "groupage", value: groupage_id}
                ] : {
                    filters: [
                        [
                            {field: "groupage", operator: "isnull"},
                            {field: "serviceprovider_type", value: "booklog_shipping"},
                            {field: "partner", value: props.groupage.partner.partner_id},
                            {field: "origin", value: props.groupage.origin},
                            {field: "destination", value: props.groupage.destination},
                            {field: "state", value: 0},
                        ],
                        {field: "groupage", value: groupage_id}
                    ],
                    operator: "OR"
                },
                itemsperpage: 1,
                view: ["id"],
            });
            loadList.then((response) => {
                if (type === "part") {
                    setInGroupageCount(response.fullcount);
                } else {
                    setFullCount(response.fullcount);
                }
            })
        }, 300);
        let abort = () => {
            timeout && clearTimeout(timeout);
            loadList?.abort();
        }
        return () => {
            abort();
        }
    }
    useEffect(() => {
        const full = loadList(props.groupage.id, "full");
        const part = loadList(props.groupage.id, "part");
        return () => {
            full();
            part();
        }
    }, []);
    useEffect(() => {
        const full = loadList(props.groupage.id, "full");
        const part = loadList(props.groupage.id, "part");
        return () => {
            full();
            part();
        }
    }, [props.groupage.id, props.selected, props.isLoading]);
    return fullCount !== null && inGroupageCount !== null ? <div className="pull-right label label-default" style={{fontSize: "20px"}}>
        {inGroupageCount}/{fullCount}
    </div> : null;
}

const GroupageTable = (props) => {
    return <Fragment>
        {parseInt(props.parent.state || "0") === 0 ? <props.fields.actions.props.header.type {...props.fields.actions.props.header.props} {...props} /> : null}
        <label className="control-label">Túrában lévő gyűjtők</label>
        <div className="p-datagrid p-datacards">
            <div className="row">
                {props.data.items.map((item, rowIdx) => {

                    let selectedIdx = props.selectorFunction({
                        item,
                        items: props.data.items,
                        selection: props.selection,
                        props: props
                    });

                    return <div key={rowIdx} className="col-md-4 my-1">
                        <div
                            className={classNames("card", {"card-primary": selectedIdx !== -1, "card-success": !(selectedIdx !== -1) && parseInt(item.state || "0") === 3})}
                        >
                            <div
                                className="card-body"
                                onClick={() => {
                                    props.onSelectionChange && props.onSelectionChange({item, selectedIdx, rowIdx});
                                }}
                            >
                                <CountGroupageShippingOrder groupage={item} selected={selectedIdx !== -1} isLoading={props.isLoading} />
                                <div className="card-title"><b>{item.tracking_id}</b></div>
                                <div className="card-text">{item.destination}</div>
                                <div className="card-text"><i>{AddressFormatter(item.destination_address)}</i></div>
                                <div className="card-subtitle mb-2 text-muted">{item.partner.name}</div>
                                <div className="card-text">{item.order_date}</div>
                            </div>
                            <ul className="list-group list-group-flush">
                                {AddressFormatter(item.destination_address) ?
                                    <a className="list-group-item" onClick={(e) => {
                                        e.preventDefault(); e.stopPropagation();
                                        window.open("https://maps.google.com/?q=" + encodeURIComponent(AddressFormatter(item.destination_address).split(';').shift()), "_blank");
                                    }} href={"https://maps.google.com/?q=" + encodeURIComponent(AddressFormatter(item.destination_address).split(';').shift())} target="_blank">Térkép</a>
                                : null}
                                {
                                    parseInt(item.state || "0") === 0 ? <Confirm
                                        header="Biztos?"
                                        body="Biztos minden csomagot hozzáadsz a túrához amit erre a címre kell szállítanod?"
                                        color="warning"
                                        onAccept={async () => {
                                            await postData({
                                                action: 'Groupage.addAllShippingOrder',
                                                id: item.id
                                            });
                                            props.refresh();
                                        }}
                                    >
                                        <li className="list-group-item list-group-item-warning">Minden csomag hozzáadása</li>
                                    </Confirm> : null
                                }
                                {
                                    parseInt(item.state || "0") === 0 ? <Confirm
                                        {...smallDeleteProps}
                                        onAccept={() => props.removeItems([item])}
                                    >
                                        <li className="list-group-item list-group-item-danger">Törlés</li>
                                    </Confirm> : null
                                }
                            </ul>
                        </div>
                    </div>
                })}
            </div>
            <Pagination {...props} />
            {props.isLoading ? <div className="loader"><ContentLoader /></div> : null}
        </div>
    </Fragment>
}

const ShippingOrderList = (props) => {
    const [selectedFilter, setSelectedFilter] = useState(false);
    let filter = list(props.filter);
    filter.push({field: "state", value: 0});
    filter.push({field: "groupage", operator: "isnull"});
    if (props.selectedFilter) {
        if (selectedFilter) {
            filter.push({field: "shippingorder_id", value: props.selection.length ? props.selection.map(({shippingorder_id}) => shippingorder_id) : [-1], operator: "in"});
        }
    }
    return <DataGrid
        {...props}
        component="shippingorder"
        filter={filter}
        view={["shippingorder_id","partner.partner_id"]}
        type={ShippingOrderTable}
        paginationRight={(p) => {
            if (!props.selectedFilter) return null;
            return <Tooltip title={!selectedFilter ? "Csak a kiválasztottakat mutasd" : "Mindent mutat"}>
                <CheckBox
                    onIcon={{lib: "fa", name: "box"}}
                    offIcon={{lib: "fa", name: "box-open"}}
                    value={1}
                    checked={selectedFilter}
                    label={false}
                    disabled={p.isLoading || p.disabled}
                    saveChanges={() => {
                        setSelectedFilter(!selectedFilter);
                    }}
                />
            </Tooltip>
        }}
        fields={{
            ...(!props.groupBy ? {
                "tracking_id": {
                    props: {
                        header: 'Követési kód',
                        width: 1,
                        sortable,
                        filterable
                    }
                },
                "pid": {
                    props: {
                        header: 'Azonosító',
                        width: 1,
                        sortable,
                        filterable
                    }
                },
            } : {}),
            "origin": {
                props: {
                    header: 'Honnan',
                    width: 2,
                    sortable,
                    filterable
                }
            },
            "origin_address": {
                props: {
                    header: 'Honnan',
                    width: 2,
                    sortable,
                    filterable
                }
            },
            "destination": {
                props: {
                    header: 'Hová',
                    width: 2,
                    sortable,
                    filterable
                }
            },
            "destination_address": {
                props: {
                    header: 'Hová',
                    width: 2,
                    sortable,
                    filterable
                }
            },
            "partner.name": {
                props: {
                    header: 'Megrendelő',
                    width: 2,
                    sortable,
                    filterable
                }
            },
            ...(!props.groupBy ? {
                "order_date": {
                    props: {
                        header: 'Rendelés időpontja',
                        order: "DESC",
                        width: 2,
                        sortable,
                        filterable,
                        formatter: ({value}) => DateTimeFormatter(value)
                    }
                },
            } : {}),
        }}
        selectionMode="multiple"
    />
}

const GroupageList = (props) => {
    return <Fragment>
        <ShippingOrderList
            {...props}
            groupBy={{
                by: ["origin", "destination", "partner"]
            }}
        />
    </Fragment>
}

const AddShippingOrder = (props) => {
    const [selectedShippingOrders, setSelectedShippingOrders] = useState([]);
    const [scannerValue, setScannerValue] = useState(null);
    const [scannerState, setScannerState] = useState(null);
    let loadShippingOrderRequest;
    const loadShippingOrderDebounce = debounce((value) => {
        loadShippingOrderRequest?.abort();
        loadShippingOrderRequest = postData({
            action: props.componentConfig.componentname + ".findShippingOrderByInput",
            input: value
        });
        loadShippingOrderRequest.then(({shippingorder}) => {
            if (shippingorder?.shippingorder_id) {
                setScannerValue(null);
                setScannerState(null);
                beepSuccess.play();
                setSelectedShippingOrders(removeDuplicates([...selectedShippingOrders, shippingorder], "shippingorder_id"));
            } else {
                beepError.play();
                setScannerState("Nincs találat!");
            }
        });
    }, 300);
    const loadShippingOrder = useCallback(
        (value) => {
            setScannerValue(value);
            setScannerState(null);
            loadShippingOrderRequest?.abort();
            loadShippingOrderDebounce(value);
        },
        [setSelectedShippingOrders, selectedShippingOrders]
    );
    return <Confirm
        size="large"
        color="primary"
        header="Csomagok hozzáadása a túrához"
        icon={{lib: "fas", name: "box"}}
        className="btn-package"
        body={<Fragment>
            <CodeScanner
                error={scannerState}
                value={scannerValue}
                saveChanges={(field, value) => {
                    loadShippingOrder(value);
                }}
            />
            <ShippingOrderList
                selection={selectedShippingOrders}
                selectedFilter={true}
                onSelectionChange={(selection) => {
                    setSelectedShippingOrders([...(selection.value || [])]);
                }}
            />
        </Fragment>}
        onCancel={() => {
            setScannerValue(null);
            setScannerState(null);
        }}
        acceptAble={!!selectedShippingOrders.length}
        onAccept={async () => {
            await postData({
                action: 'ShippingTour.addShippingOrder',
                id: props.parent[props.componentConfig.idfield],
                items: selectedShippingOrders
            });
        }}
    >
        Csomagok
    </Confirm>
}

const AddGroupages = (props) => {
    const [groupages, setGroupages] = useState([]);
    return <div className="row">
        <div className="col-xs-6">
            <AddShippingOrder {...props} />
        </div>
        <div className="col-xs-6">
            <Confirm
                header="Gyűjtők hozzáadása"
                icon={{lib: "fas", name: "boxes"}}
                className="btn-groupage"
                body={<Fragment>
                    <div className="row form-row">
                        <div className="col-md-12">
                            <label className="control-label">Gyűjtők</label>
                            <GroupageList
                                isLoading={props.isLoading}
                                selection={groupages}
                                onSelectionChange={(selection) => {
                                    setGroupages([...(selection.value || [])]);
                                }}
                            />
                        </div>
                    </div>
                </Fragment>}
                size="large"
                color="primary"
                acceptAble={!!groupages.length}
                onAccept={async () => {
                    await props.addItems(groupages);
                    setGroupages([]);
                }}
            >
                Gyűjtők
            </Confirm>
        </div>
    </div>
}

const ShippingTourGroupagesList = React.forwardRef((props, ref) => {
    const groupagesRef = useRef(null);
    const {selectedGroupage, setSelectedGroupage} = props;
    const shippingsRef = useRef(null);
    const [signature, setSignature] = useState(null);
    const [clerk, setClerk] = useState(null);

    return <Fragment>
        <div className="row form-row">
            <div className="col-md-12">
                <DataGrid
                    {...props.getFieldProps("groupages")}
                    ref={refs(groupagesRef, ref)}
                    data={props.values}
                    parent={props.values}
                    componentConfig={props.componentConfig}
                    name="groupages"
                    view={["id","partner.partner_id"]}
                    type={GroupageTable}
                    fields={{
                        "actions": {
                            props: {
                                header: <AddGroupages parent={props.values} />,
                                width: "auto",
                                label: false,
                                parent: props.values,
                                formatter: ({value, removeItems, rowKey}) => {
                                    return <Confirm
                                        {...smallDeleteProps}
                                        onAccept={async () => {
                                            removeItems({[rowKey]: value});
                                        }}
                                    />;
                                }
                            }
                        },
                        "tracking_id": {
                            props: {
                                header: 'Követési kód',
                                width: 1,
                                sortable,
                                filterable
                            }
                        },
                        "partner.name": {
                            props: {
                                header: 'Megrendelő',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin_address": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "destination": {
                            props: {
                                header: 'Címzett',
                                order: "DESC",
                                width: 2
                            }
                        },
                        "destination_address": {
                            props: {
                                header: 'Hová',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "state": {
                            props: {
                                header: 'Státusz',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                    }}
                    removeItems={async (items) => {
                        items.forEach((groupage) => {
                            if (groupage.id + "" === "" + selectedGroupage) {
                                setSelectedGroupage(null);
                            }
                        });
                        return items;
                    }}
                    selection={selectedGroupage}
                    onSelectionChange={(selection) => {
                        setSelectedGroupage(selection.value);
                    }}
                />
            </div>
        </div>
        {selectedGroupage && <Portal>
            <Modal
                state="on"
                size="large"
                header="Gyűjtőben lévő csomagok"
                footer={<Fragment>
                    {parseInt(selectedGroupage.state || "0") === 0 ? <Confirm
                        header="Biztos?"
                        body="Biztos minden csomagot hozzáadsz a túrához amit erre a címre kell szállítanod?"
                        color="warning"
                        onAccept={async () => {
                            await postData({
                                action: 'Groupage.addAllShippingOrder',
                                id: selectedGroupage.id
                            });
                            shippingsRef?.current?.refresh();
                        }}
                    >
                        Minden csomag hozzáadása
                    </Confirm> : null}
                    {parseInt(selectedGroupage.state || "0") === 1 ? <Button
                        onClick={() => {
                            let url = UrlGenerator();
                            delete url.fragment;
                            url.query = {
                                option: "Groupage",
                                id: selectedGroupage.id,
                                resptype: "pdf"
                            };
                            window.open(url.toString(), '_blank');
                        }}
                        color="default"
                    >
                        Szállítólevél
                    </Button> : null}
                    {parseInt(selectedGroupage.state || "0") === 1 ? <Confirm
                        header="Lezárás"
                        size="medium"
                        color="danger"
                        body={<Fragment>
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <SignaturePad
                                        name="signature"
                                        label="Aláírás"
                                        type="file"
                                        filename="signature"
                                        value={signature}
                                        saveChanges={(field, value) => {
                                            setSignature(value);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row form-row">
                                <div className="col-md-12">
                                    <TextInput
                                        name="clerk"
                                        label="Átvevő"
                                        type="text"
                                        value={clerk}
                                        saveChanges={(field, value) => {
                                            setClerk(value);
                                        }}
                                    />
                                </div>
                            </div>
                        </Fragment>}
                        onCancel={() =>{
                            setSignature(null);
                            setClerk(null);
                        }}
                        onAccept={async () => {
                            const r = await postData({
                                action: "Groupage.proceedState",
                                id: selectedGroupage.id,
                                data: {
                                    signature,
                                    clerk
                                }
                            });
                            setSignature(null);
                            setClerk(null);
                            setSelectedGroupage(r.data);
                        }}>
                        Lezárás
                    </Confirm> : null}
                </Fragment>}
                buttons={[
                    {
                        text: "Bezárás",
                        className: "pull-left",
                        props: {
                            color: "default",
                            disabled: props.disabled || props.isLoading
                        },
                        onClose: true,
                        onClick: () => {
                            setSelectedGroupage(null);
                        }
                    }
                ]}
            >
                <DataGrid
                    {...props.getFieldProps("shippingorders")}
                    ref={shippingsRef}
                    component="Groupage"
                    data={selectedGroupage}
                    parent={selectedGroupage}
                    name="shippingorders"
                    type={ShippingOrderTable}
                    view={["shippingorder_id"]}
                    fields={{
                        "actions": {
                            props: {
                                header: " ",
                                width: "auto",
                                label: false,
                                parent: props.values,
                                formatter: ({value, removeItems, rowKey}) => {
                                    return <Confirm
                                        {...smallDeleteProps}
                                        onAccept={async () => {
                                            removeItems({[rowKey]: value});
                                        }}
                                    />;
                                }
                            }
                        },
                        "tracking_id": {
                            props: {
                                header: 'Követési kód',
                                width: 1,
                                sortable,
                                filterable
                            }
                        },
                        "pid": {
                            props: {
                                header: 'Azonosító',
                                width: 1,
                                sortable,
                                filterable
                            }
                        },
                        "partner.name": {
                            props: {
                                header: 'Megrendelő',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "origin_address": {
                            props: {
                                header: 'Honnan',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "destination": {
                            props: {
                                header: 'Címzett',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "destination_address": {
                            props: {
                                header: 'Hová',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                        "order_date": {
                            props: {
                                header: 'Rendelés időpontja',
                                order: "DESC",
                                width: 2,
                                sortable,
                                filterable,
                                formatter: ({value}) => DateTimeFormatter(value)
                            }
                        },
                        "state": {
                            props: {
                                header: 'Státusz',
                                width: 2,
                                sortable,
                                filterable
                            }
                        },
                    }}
                />
            </Modal>
        </Portal>}
    </Fragment>
})

class ShippingTourForm extends React.Component {

    groupages = React.createRef();

    render() {
        const groupagesProps = this.props.getFieldProps("groupages");
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput
                            {...this.props.getFieldProps("name")}
                            name="name"
                            value={this.props.values.name}
                            label="Név"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                {this.props.values[this.props.componentConfig.idfield] ?
                    <Fragment>
                        <ShippingTourGroupagesList
                            ref={this.groupages}
                            {...this.props}
                        />
                    </Fragment>
                    :
                    <Fragment>
                        <div className="row form-row">
                            <div className="col-md-12">
                                <label className="control-label">Gyűjtők</label>
                                <GroupageList
                                    possibleOrders={true}
                                    isLoading={this.props.isLoading}
                                    selection={this.props.values.groupages}
                                    onSelectionChange={(selection) => {
                                        this.props.setFieldValue("groupages", selection.value);
                                    }}
                                />
                                {groupagesProps.error && <div className="invalid-feedback">{groupagesProps.error}</div>}
                            </div>
                        </div>
                    </Fragment>
                }
            </form>
        );
    }
}

export default createForm(ShippingTourForm);
